import React from 'react';
import { Row } from 'reactstrap';
import DefaultModal from '../../../../../components/Modal/DefaultModal';
import Loader from 'react-loader-spinner';
import SLAProgressBar from './components/SLAProgressBar';
import { formatTimeToDHM } from './utils';

const ModalSLAInfo = ({
  isModalOpen,
  onModalToggle,
  protocolSLAInfoTime,
  isLoadingSLAInfo
}) => {
  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title={'Informações do SLA'}
      showCloseButton={true}
      modalContainerClasses="modal-md"
    >
      {isLoadingSLAInfo ? (
        <Row className="justify-content-md-center">
          <Loader type="TailSpin" color="#35ac50" height={100} width={100} />
        </Row>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1.3rem',
            width: '100%',
            padding: '0rem 2rem'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              justifyContent: 'space-between'
            }}
          >
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              <p>Tempo Total de Atendimento: </p>
              <strong>
                {formatTimeToDHM(protocolSLAInfoTime?.sla_service)}
              </strong>
            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              <p>Tempo Total de Solução: </p>
              <strong>
                {formatTimeToDHM(protocolSLAInfoTime?.sla_solution)}
              </strong>
            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              <p>Tempo Restante de Atendimento: </p>
              <strong>
                {formatTimeToDHM(protocolSLAInfoTime?.remain_sla_service_time)}
              </strong>
            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              <p>Tempo Restante de Solução: </p>
              <strong>
                {formatTimeToDHM(protocolSLAInfoTime?.remain_sla_solution_time)}
              </strong>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '3rem',
              width: '100%',
              justifyContent: 'space-between'
            }}
          >
            <div
              style={{
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <h4>SLA de Atendimento</h4>
              <SLAProgressBar
                total={protocolSLAInfoTime?.sla_service}
                remaining={protocolSLAInfoTime?.remain_sla_service_time}
              />
            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <h4>SLA de Solução</h4>
              <SLAProgressBar
                total={protocolSLAInfoTime?.sla_solution}
                remaining={protocolSLAInfoTime?.remain_sla_solution_time}
              />
            </div>
          </div>
        </div>
      )}
    </DefaultModal>
  );
};

export default ModalSLAInfo;
